import cls from "classnames";
import PageWithLeftSidebar from "components/page/PageContentWithLeftSidebar/PageContentWithLeftSidebar";
import PageWithHeaderFooter from "components/page/PageWithHeaderFooter/PageWithHeaderFooter";
import ExerciseListSidePanel from "components/page/sidePanel/ExerciseListSidePanel/ExerciseListSidePanel";
import StudentListSidePanel from "components/page/sidePanel/StudentListSidePanel/StudentListSidePanel";
import { LogoSpinner } from "components/ui/Spinner";
import { useUser } from "contexts/UserContext";
import { routes } from "pages/routes";
import { PropsWithChildren, useEffect } from "react";
import { Location, useLocation } from "react-router";
import { EnhancedUser } from "services/users/utils";
import { useDocumentTitle } from "utils/useDocumentTitle";
import AppFooter from "./AppFooter";
import PageHeader from "./PageHeader";
import "./PageLayout.css";

export function Layout({ children }: PropsWithChildren) {
  const location = useLocation();
  const user = useUser(false);

  useDocumentTitle("Talaera");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (user === undefined) {
    return (
      <div className="page-spinner-container">
        <LogoSpinner size="large" />
      </div>
    );
  }

  const sidebar = getSidebar(user, location);
  const pageContent = sidebar ? (
    <PageWithLeftSidebar leftSidebar={sidebar} pageContent={children} />
  ) : (
    children
  );
  const contentWrapperClass = cls("page-content", {
    "flex-container": usesFlexContentLayout(location.pathname),
  });

  return (
    <PageWithHeaderFooter
      header={<PageHeader />}
      footer={<AppFooter />}
      pathname={location.pathname}
    >
      <div className={contentWrapperClass}>{pageContent}</div>
    </PageWithHeaderFooter>
  );
}

function getSidebar(user: EnhancedUser | null | undefined, location: Location) {
  if (
    routes.studentDetails.match(location.pathname) ||
    routes.students.match(location.pathname)
  ) {
    return <StudentListSidePanel location={location} />;
  }

  if (
    user?.isTeacher &&
    (routes.exercises.match(location.pathname) ||
      routes.exercisesByCreator.match(location.pathname))
  ) {
    return <ExerciseListSidePanel location={location} />;
  }

  return null;
}

function usesFlexContentLayout(path: string) {
  return routes.practice.match(path) || routes.payment.match(path);
}
